import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { StyledEnrichmentToggle } from "app/pages/sales-intelligence/modules/crm-enrichment/components/CrmEnrichmentToggle/styles";

const LOADING_TOGGLES_QUANTITY = 3;

const EnrichmentSectionLoader = () => {
    return Array.from({ length: LOADING_TOGGLES_QUANTITY }, (_, index) => (
        <StyledEnrichmentToggle key={index}>
            <PixelPlaceholderLoader
                height={20}
                width="90%"
            />
        </StyledEnrichmentToggle>
    ));
};

export default EnrichmentSectionLoader;
